import TabbedNav from './TabbedNav';

export default TabbedNav;
